import { useDispatch } from "react-redux";
import { sidebarOpen } from "../../../../redux/reducers/sidebarReducer";
// import { DASHBOARD_SIDEBAR_TYPES } from "../DASHBOARD_SIDEBAR_TYPES";
import { EditOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { DASHBOARD_SIDEBAR_TYPES } from "../DashboardSidebar";

const SidebarEditProfileDataIconButton = () => {
  const dispatch = useDispatch();

  const handleOnClick = () => {
    dispatch(
      sidebarOpen(
        DASHBOARD_SIDEBAR_TYPES.EDIT_BORROWER_PROFILE, // type
        // { loanId: "12345" }, // data
        // { source: "conditions-tab" }, // metadata
      ),
    );
  };

  return (
    <Tooltip title="Edit Profile Data">
      <IconButton size="small" onClick={handleOnClick}>
        <EditOutlined className="thin" />
      </IconButton>
    </Tooltip>
  );
};

export default SidebarEditProfileDataIconButton;
